import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import useApi from 'utils/hooks/api/useApi';
import { sessionActions } from 'redux/actions';
import { HTTP_VERBS } from 'utils/constants';

const path = `external/users/current`;

const useSession = (loggedIn = false) => {
  const dispatch = useDispatch();
  const [{ result: session, loading: loadingSession, error }, getSession] = useApi(`${path}?loggedIn=${loggedIn}`, {
    initialFetch: false,
    verb: HTTP_VERBS.GET,
  });

  useEffect(() => {
    async function fetchSession() {
      if (session) dispatch(sessionActions.setUserInfo(session));
    }
    fetchSession();
  }, [session, dispatch]);

  return [{ session, loadingSession, error }, getSession];
};

export default useSession;
